<script lang="ts" setup>
import FixedRouterView from "@/components/fix/FixedRouterView.vue";
import { useLocalStorage } from "@vueuse/core";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const isRootPath = computed(() => route.name === "chatList");
const isCollapsed = useLocalStorage("chatListCollapsed", false);
</script>
<template>
  <div class="h-full flex overflow-hidden">
    <div
      :class="{
        'block lg:flex-none flex-1': isRootPath,
        'hidden lg:block': !isRootPath,
        'sm:w-[450px]': !isCollapsed,
        'sm:w-[70px]': isCollapsed,
      }"
      class="border-e sm:w-[450px]"
    >
      <ChatList v-model:isCollapsed="isCollapsed" />
    </div>
    <div :class="isRootPath ? 'hidden lg:block' : 'block'" class="flex-1">
      <fixed-router-view v-slot="{ Component }">
        <component :is="Component" />
      </fixed-router-view>
    </div>
  </div>
</template>
